import i18n from "../i18n";
import {
  traditionalChinesePagePatterns,
  traditionalChinesePageText,
} from "../locales/pageTranslations";
import { dialogText } from "./dialogText";


export function pageText(value) {
  if (typeof value !== "string") return value;
  if ((i18n.resolvedLanguage || i18n.language) !== "zh-TW") return value;

  const directTranslation = traditionalChinesePageText[value];
  if (directTranslation) return directTranslation;

  const pattern = traditionalChinesePagePatterns.find(([source]) =>
    source.test(value)
  );
  if (pattern) return value.replace(pattern[0], pattern[1]);

  return dialogText(value);
}
